import React from 'react';
import { Link } from 'react-router-dom';
import PickupLocation from '../components/classified/PickupLocation';
import BannerAd from '../components/ibok-core/module/BannerAd';
import useAdsBannerForPage from '../hooks/useAdsBannerForPage';
import { getSellerPage } from '../utils/api/classifiedApi';
import { mapConditionToLabel } from '../utils/classifiedUtil';
import { humanTimeDiff } from '../utils/dateUtil';
var formatPrice = function (price) { return price + ",-"; };
var pageHref = function (sellerId, page, limit) { return ("/selger/" + sellerId + "?page=" + encodeURIComponent(page) + "&limit=" + encodeURIComponent(limit)); };
var SellerClassifiedBook = function (_a) {
    var classified = _a.classified;
    return (React.createElement("section", { className: "object book" },
        React.createElement("h2", null,
            React.createElement("a", { href: "/bok/" + classified.isbn + "?focus_on=" + classified.id }, classified.title)),
        React.createElement("p", null,
            "ISBN\u00A0",
            classified.isbn)));
};
/**
 * The public seller page — displays a seller's
 * active classifieds, paginated.
 * */
var SellerPage = function (_a) {
    var sellerId = _a.sellerId, page = _a.page, limit = _a.limit;
    var banners = useAdsBannerForPage('seller').banners;
    var _b = React.useState(null), seller = _b[0], setSeller = _b[1];
    var _c = React.useState(true), isLoading = _c[0], setIsLoading = _c[1];
    var _d = React.useState(false), isMissing = _d[0], setIsMissing = _d[1];
    var _e = React.useState(null), error = _e[0], setError = _e[1];
    React.useEffect(function () {
        var isMounted = true;
        setSeller(null);
        setIsMissing(false);
        setError(null);
        setIsLoading(true);
        getSellerPage(sellerId, page, limit)
            .then(function (nextSeller) {
            if (isMounted) {
                setSeller(nextSeller);
            }
        })
            .catch(function (err) {
            if (!isMounted) {
                return;
            }
            if (err && err.status === 404) {
                setIsMissing(true);
                return;
            }
            setError('Kunne ikke hente selgersiden. Prøv igjen om litt.');
        })
            .finally(function () {
            if (isMounted) {
                setIsLoading(false);
            }
        });
        return function () {
            isMounted = false;
        };
    }, [sellerId, page, limit]);
    if (isLoading) {
        return React.createElement("div", { className: "main-content" },
            React.createElement("h1", null, "Laster selgerside"));
    }
    if (isMissing) {
        return React.createElement("div", { className: "main-content" },
            React.createElement("h1", null, "Fant ikke selgeren"),
            React.createElement("p", null, "Denne selgersiden finnes ikke lenger, eller selgeren har skjult den."),
            React.createElement("a", { href: "/" }, "Til forsiden"));
    }
    if (error || !seller) {
        return React.createElement("div", { className: "main-content", role: "alert" },
            React.createElement("h1", null, "Selgerside"),
            React.createElement("p", null, error));
    }
    var pagination = seller.pagination;
    return React.createElement("div", { className: "main-content" },
        React.createElement(BannerAd, { banners: banners, page: "seller", size: "desktop" }),
        React.createElement("h1", null, seller.name),
        React.createElement("div", null,
            seller.phone && React.createElement("p", null,
                "Tlf: ",
                seller.phone),
            seller.hasVipps && React.createElement("p", null,
                React.createElement("i", { className: "vipps nohover uncontained", style: { marginRight: '0.5em' }, title: "Selger st\u00F8tter betaling gjennom Vipps" }),
                " er st\u00F8ttet av selger")),
        seller.classifieds.length === 0
            ? React.createElement("p", null, "Denne selgeren har ingen annonser.")
            : React.createElement("div", null,
                React.createElement("ul", null, seller.classifieds.map(function (classified) { return React.createElement("li", { className: "object composite", key: classified.id },
                    React.createElement(SellerClassifiedBook, { classified: classified }),
                    React.createElement("div", { className: "object classified" },
                        React.createElement(PickupLocation, { classified: classified }),
                        React.createElement("strong", { className: "price" }, formatPrice(classified.price)),
                        React.createElement("div", { className: "vertical vertical-center" },
                            React.createElement("strong", { className: "condition" }, mapConditionToLabel(classified.condition)),
                            React.createElement("small", null,
                                "Sist oppdatert: ",
                                humanTimeDiff(classified.lastUpdated || undefined, Date.now()))),
                        React.createElement("a", { className: "button", href: "/bok/" + classified.isbn + "?focus_on=" + classified.id }, "G\u00E5 til annonsen"))); })),
                React.createElement("strong", null,
                    "Side: ",
                    pagination.page,
                    " av ",
                    pagination.totalPages),
                React.createElement("div", { className: "columns nogrow" },
                    pagination.hasPrevious && React.createElement(Link, { className: "button nogrow", to: pageHref(seller.id, pagination.page - 1, pagination.limit) }, "Forrige side"),
                    pagination.hasNext && React.createElement(Link, { className: "button nogrow", to: pageHref(seller.id, pagination.page + 1, pagination.limit) }, "Neste side"))));
};
export default SellerPage;
